var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "video-outer" }, [
    _c("div", { staticClass: "video-inner" }, [
      _c("iframe", {
        staticClass: "video",
        attrs: {
          id: "printf",
          name: "printf",
          src: _vm.src,
          allow: "autoplay; fullscreen; picture-in-picture",
          allowfullscreen: "",
          frameborder: "0",
          width: "100%",
          height: "100%",
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }